<template>
	<div>
		<div v-for="item in items" class="b-basket__item" :class="{loading: isLoadingItem(item) || fictiveLoading.includes(item.product_id)}" :key="item.product_id + '-'+item.id">
			<a @click="removeItem(item)" href="javascript:void(0);" class="b-basket__remove" :title="loc.CITRUS_VUE_BASKET_ITEMS_DELETE" v-html="`&times;`"></a>

			<div class="b-basket__item-content">
				<div class="b-basket__imgWrap">
					<img :src="!!item.picture_src ? item.picture_src : NO_IMAGE" :data-src="item.picture_src" class="b-basket__img"/>
				</div>

				<div class="b-basket__item-top">
					<div class="b-basket__note" v-if="item.article" v-html="loc.CITRUS_VUE_BASKET_ITEMS_ARTICLE + ' ' + item.article"></div>
					<div class="b-basket__note" v-if="item.xmlId" v-html="loc.CITRUS_VUE_BASKET_ITEMS_XML_ID+' ' + item.xmlId"></div>
				</div>

				<a v-if="item.detail_page_url" class="b-basket__itemName" :href="item.detail_page_url"
				   v-html="item.name"></a>
				<span v-else class="b-basket__itemName" v-html="item.name"></span>
				<div class="b-basket__itemFooter">
					<citrus-product-basket-quantity
						v-if="!viewMode"
						:class="'b-counter_catalog b-counter_basket'"
						:id="item.product_id"
						:max-quantity="item.catalogQuantity"
						:quantity="item.quantity"
						@change="changeQuantity"
						@fictiveLoading="onFictiveLoading"
					>
					</citrus-product-basket-quantity>
					<div v-else>
						<span v-html="item.quantity"></span>
					</div>
					<div class="b-price b-price_basket b-basket__itemPrice">
						<div class="b-price__item b-price__item_current">
							<span v-html="formatPrice(item.sum, false, item.currency)"></span>
						</div>
						<div class="b-price__item b-price__item_old" v-if="item.full_sum && item.full_sum > item.sum">
							<span v-html="formatPrice(item.full_sum, false, item.currency)"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {Vue} from "ui.vue";
	import {store} from "citrus.vuex.store";

	import {FormatMixin} from "citrus.vue.mixin.format";
	import "citrus.vue.product.basket-button";

	export default {
		name: "BasketItems",
		store: store,
		mixins: [FormatMixin],
		props: {
			viewMode: {
				type: [Boolean],
				default: false
			},
			items: {
				type: [Object, Array],
				default: function () {
					return []
				}
			},
		},
		data: function () {
			return {
				fictiveLoading: [],
				NO_IMAGE: window.NO_IMAGE
			};
		},
		computed: {
			loc() {
				return Vue.getFilteredPhrases("CITRUS_VUE_BASKET_ITEMS_");
			}
		},
		methods: {
			isLoadingItem(item) {
				return this.$store.getters['basket/loading'](item.product_id);
			},
			removeItem: function (item) {
				if (!this.isLoadingItem(item)) {
					this.$store.dispatch("basket/remove", item.product_id);
				}
			},
			changeQuantity: function (params) {
				this.$store.dispatch("basket/change", params);
			},
			onFictiveLoading: function ({id, fictiveLoading}) {
				if (fictiveLoading) {
					if (!this.fictiveLoading.includes(id)) {
						this.fictiveLoading.push(id);
					}
				} else {
					this.fictiveLoading = this.fictiveLoading.filter(elem => elem !== id);
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				BX.onCustomEvent(window.ON_UPDATE_DOM);
			});
		}
	}
</script>